export const portSizeOptions = [
  { id: 'Big', name: 'Big', label: 'Big' },
  { id: 'Small', name: 'Small', label: 'Small' },
  { id: 'Very Small', name: 'Very Small', label: 'Very Small' }
];
